import { useState, useRef, useEffect } from 'react';

export function useDropdownVisibility(dropdownKeys = []) {
  // State to track visibility of dropdowns
  const [visibilityState, setVisibilityState ] = useState(
    dropdownKeys.reduce((acc, key) => ({ ...acc, [key]: false }), {}),
  );

  // Ref to track the currently open dropdown
  const refs = useRef(
    dropdownKeys.reduce((acc, key) => ({ ...acc, [key]: null }), {}),
  );

  // init Refs
  useEffect(() => {
    dropdownKeys.forEach((key) => {
      if (!refs.current[key]) {
        refs.current[key] = { current: null };
      }
    });
  }, [dropdownKeys]);

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      dropdownKeys.forEach(key => {
        const ref = refs.current[key];
        if (ref?.current && !ref.current.contains(event.target)) {
          setVisibilityState(prev => ({
            ...prev,
            [key]: false,
          }));
        }
      })
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownKeys]);

  // Toggle specific dropdown visibility
  const toggleDropdown = (key) => {
    setVisibilityState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  }

  // Close as specific dropdown
  const closeDropdown = (key) => {
    setVisibilityState((prev) => ({
      ...prev,
      [key]: false,
    }));
  }

  // Close all dropdowns\
  const closeAllDropdowns = () => {
    setVisibilityState(dropdownKeys.reduce((acc, key) => ({ ...acc, [key]: false }), {}));
  }

  return {
    // State
    visibilityState,
    refs: refs.current,

    // Actions
    toggleDropdown,
    closeDropdown,
    closeAllDropdowns,

    // Direct setters
    setVisibilityState,
  };
}
